import React, { useEffect, useState } from "react";
import { Modal, Form, Row, Col, Input, Select, Radio, message, InputNumber } from "antd";
import { labelTooltip as LabelTooltip } from "../../../components/util";
import { ICompetence, ICompetenceType } from "./types";
import { FormComponentProps } from "antd/lib/form";
import { saveOrUpdate, select } from "../actions/dimensionsAndType";
import { Utilitaries } from "../../../business";

const { Option } = Select;

interface IProps extends FormComponentProps {
    record?: ICompetence;
    onClose: (reload?: boolean) => void;
}

function FormCompetence({ onClose, record, form }: IProps) {
    const [isSaving, setIsSaving] = useState(false);
    const [competenceTypeList, setCompetenceTypeList] = useState<ICompetenceType[]>([]);
    const [loadingTypes, setLoadingTypes] = useState(true);

    const { getFieldDecorator } = form;

    useEffect(() => {
        select({
            accao: "lista",
            lista: "tipos_competencias",
            pagina: 1,
            resultados_pagina: 0,
        })
            .then((response) => {
                const list: ICompetenceType[] = Utilitaries.toArray(response.linha);
                const data = list.map((item) => ({
                    ...item,
                    designacao: typeof item.designacao === "object" ? "" : item.designacao,
                    descricao: typeof item.descricao === "object" ? "" : item.descricao,
                }));
                setCompetenceTypeList(data);
                setLoadingTypes(false);
            })
            .catch(() => {
                message.error("Erro ao carregar os tipos de requisitos");
                onClose();
            });
    }, [onClose]);

    function handleOk() {
        form.validateFields((err, values) => {
            console.log("values", values);
            if (!err) {
                setIsSaving(true);

                const objToSave = record
                    ? {
                          id_competencia: record.id_competencia,
                          activo: true,
                          versao: record.versao !== "" ? record.versao + 1 : 1,
                      }
                    : {
                          versao: 1,
                      };

                const data = JSON.stringify({
                    competencia: {
                        ...values,
                        ...objToSave,
                        activo: true,
                    },
                });

                saveOrUpdate({
                    accao: "guardar",
                    formulario: "qa_competencias.xml",
                    dados: data,
                })
                    .then((sucess) => {
                        if (sucess) {
                            message.success("Guardado");
                            onClose(true);
                        } else {
                            message.error("Ocorreu um erro");
                            setIsSaving(false);
                        }
                    })
                    .catch(() => {
                        message.error("Ocorreu um erro");
                        setIsSaving(false);
                    });
            }
        });
    }

    return (
        <Modal
            style={{ top: 10 }}
            title={record ? "Editar competência" : "Nova competência"}
            visible
            onOk={handleOk}
            onCancel={() => onClose()}
            width="50%"
            confirmLoading={isSaving}
        >
            <Form layout="vertical" onSubmit={handleOk}>
                <Row gutter={18}>
                    <Col xs={24} sm={24} md={24}>
                        <Form.Item label="Tipo de competência">
                            {getFieldDecorator("tipo_competencia", {
                                initialValue: record?.id_tipo_competencia,
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório",
                                    },
                                ],
                            })(
                                <Select
                                    showSearch
                                    allowClear
                                    optionFilterProp="children"
                                    loading={loadingTypes}
                                    filterOption={(input, option) => {
                                        if (option.props.children === undefined || option.props.children === null) {
                                            return false;
                                        }

                                        return (
                                            option.props.children
                                                .toString()
                                                ?.toLowerCase()
                                                .indexOf(input.toLowerCase()) >= 0
                                        );
                                    }}
                                >
                                    {competenceTypeList.map((item) => (
                                        <Option key={item.id_tipo_competencia}>{item.designacao}</Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24}>
                        <Form.Item label="Competência">
                            {getFieldDecorator("designacao", {
                                initialValue: record?.designacao,
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório",
                                    },
                                ],
                            })(<Input />)}
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24}>
                        <Form.Item
                            label={
                                <LabelTooltip
                                    label="Contribui para QV dos clientes?"
                                    description="Indicar se a comptência contribui ou não para a qualidade de vida dos clientes."
                                />
                            }
                        >
                            {getFieldDecorator("contribui_qv", {
                                initialValue: record?.contribui_qv === "Sim" ? 1 : 0,
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório",
                                    },
                                ],
                            })(
                                <Radio.Group buttonStyle="solid">
                                    <Radio.Button value={1}>Sim</Radio.Button>
                                    <Radio.Button value={0}>Não</Radio.Button>
                                </Radio.Group>
                            )}
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                        <Form.Item label="Nº Inc. Nega.">
                            {getFieldDecorator("n_inc_cri_neg", {
                                initialValue: record?.n_inc_cri_neg,
                            })(<InputNumber style={{ width: "100%" }} min={0} />)}
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                        <Form.Item label="Nº Inc. Posi.">
                            {getFieldDecorator("n_inc_cri_posi", {
                                initialValue: record?.n_inc_cri_posi,
                            })(<InputNumber style={{ width: "100%" }} min={0} />)}
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                        <Form.Item label="Nº Sugestões">
                            {getFieldDecorator("n_sugests", {
                                initialValue: record?.n_sugests,
                            })(<InputNumber style={{ width: "100%" }} min={0} />)}
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
}

export const WrappedFormCompetence = Form.create<IProps>({
    name: "form_competence",
})(FormCompetence);
